export default __webpack_public_path__ + "static/media/emenu.67ae99eb.jpg";